export default __webpack_public_path__ + "static/media/srcn188_kama_2500x1875.b933a1b8.jpg";